<template>
  <div>
    <PageTitle
      title="Expenses"
      :btnCreate="true"
      :createRoute="'/purchase/add'"
      :createPopup="true"
      :permission="'Category Create'"
      @onClickCreate="OpenModal()"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-flex>
        <v-row>
          <!-- Expense for Warehouse -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="
                background-image: linear-gradient(to right, #432371, #faae7b);
              "
              v-if="ProductCategory.length > 0"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>
                      Warehouse ({{
                        ExpenseForWarehouse[0] ? ExpenseForWarehouse[0] : '0'
                      }})
                    </div>
                  </div>
                </v-col>

                <v-col cols="6" class="text-right font-weight-bold">
                  <div class="topCard mr-3">
                    {{
                      ExpenseForWarehouse[1]
                        ? ExpenseForWarehouse[1]
                        : '0' | formatCurrency
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- Expense for shop -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="
                background-image: linear-gradient(to right, #9bafd9, #103783);
              "
              v-if="ProductCategory.length > 0"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>
                      Shop ({{ ExpenseForShop[0] ? ExpenseForShop[0] : '0' }})
                    </div>
                  </div>
                </v-col>

                <v-col cols="6" class="text-right font-weight-bold">
                  <div class="topCard mr-3">
                    {{
                      ExpenseForShop[1]
                        ? ExpenseForShop[1]
                        : '0' | formatCurrency
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- total payments component -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="
                background-image: linear-gradient(to right, #0061ff, #60efff);
              "
              v-if="ProductCategory.length > 0"
            >
              <v-row>
                <v-col cols="6" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>Total Expenses</div>
                  </div>
                </v-col>

                <v-col cols="6" class="text-right font-weight-bold">
                  <div class="topCard mr-3">
                    {{ total | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter-outline' : 'mdi-filter' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="!show">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="[
                'search',
                'expenseFor',
                'expenseCategory',
                'dateRange',
              ]"
              v-model="filter"
              :columns="columns"
              :msgs="'Reference Number'"
            ></TableFilters>
          </v-row>
        </v-card>
      </v-expand-transition>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <v-col
          class="pr-1 text-right"
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          xl="2"
        >
          <CategoryForm
            ref="createcategory"
            :Expense="Expense"
            :visible="isCategoryFormVisible"
            @close="AddCategory($event)"
            @afterSave="refreshData()"
          />
        </v-col>
        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="ProductCategory"
          class="row-pointer"
          item-key="id"
          hide-default-footer
          @click:row="$router.push(`expenses/${$event.id}`)"
          style="font-family: 'Source Sans Pro', sans-serif"
        >
          <template v-slot:no-data>
            <noData
              class="mt-10 container justify-center item-center"
              name="shop"
            />
          </template>
          <!-- No -->
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>
          <template v-slot:item.date="{ item }" :slot-scope="props">
            {{ item.date | formatDate }}
          </template>

          <template v-slot:item.amount="{ item }" :slot-scope="props">
            {{ item.amount | formatCurrency }}
          </template>
          <template v-slot:item.due="{ item }" :slot-scope="props">
            <div class="deuamount">
              {{ (item.amount - item.paid_amount) | formatCurrency }}
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              :x-small="true"
              label
              text-color="white"
              :color="getExpenseOrderStatusColor(item.status)"
              dark
              >{{ item.status }}</v-chip
            ></template
          >

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              v-if="item.status == 'Paid' && 'Canceled'"
              feature="expenses"
              :item="item"
              refreshData
              viewPermission="Expense Show"
              editPermission="Expense Edit"
              @onEditClicked="EditModal(item)"
              :isEditModal="true"
            ></list-menu>

            <list-menu
              v-else
              feature="expenses"
              :item="item"
              refreshData
              viewPermission="Expense Show"
              editPermission="Expense Edit"
              @onEditClicked="EditModal(item)"
              :isEditModal="true"
              :isPaymentModal="true"
              @onPaymentClicked="OpenPayment(item)"
              paymentPermission="Expense Edit"
            ></list-menu>
          </template>
          <template
            slot="body.append"
            v-if="ProductCategory && ProductCategory.length > 0"
          >
          </template>

          <template v-slot:footer>
            <pagination
              url="expenses"
              @paginationOptions="setPaginationOptions"
              @getPageNumber="setPagenumber"
              :filterAction="true"
              @response="receiveCategoryData"
              :filter="filter"
              ref="pagination"
            />
          </template>
          <template v-slot:item.reference_number="{ item }">
            <div>
              {{ item.reference_number }}
            </div>
          </template>
          <template v-slot:item.date="{ item }">
            <div>
              {{ item.date | formatDate }}
            </div>
          </template>

          <template v-slot:item.shoporwarehouse="{ item }">
            <div v-if="item.expense_for == 'Warehouse'">
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="grey lighten-1"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter="warehouseNameFind(item)"
                    >mdi-information</v-icon
                  >
                </template>
                <span>{{ warehouseName }}</span>
              </v-tooltip>
              {{
                WarehouseView == 'name'
                  ? item.warehouse.sortform
                  : item.warehouse.name
              }}
            </div>
            <div v-else>
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="grey lighten-1"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter="shopNameFind(item)"
                    >mdi-information</v-icon
                  >
                </template>
                <span>{{ shopName }}</span>
              </v-tooltip>
              {{ ShopView == 'name' ? item.shop.sortform : item.shop.name }}
            </div>
          </template>
          <template v-slot:item.category.name="{ item }">
            <div>
              {{ item.category.name }}
            </div>
          </template>
          <template v-slot:item.remark="{ item }">
            <div>
              {{ item.remark }}
            </div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div>
              {{ item.amount | formatCurrency }}
            </div>
          </template>
        </v-data-table>

        <EditCategoryForm
          :visible="EditScheduleForm"
          ref="editcategory"
          :expense="Expense"
          @afterSave="refreshData()"
          @close="EditCategory($event)"
        />

        <AddPaymentModel
          ref="PaymentModal"
          :url="url"
          :expenseId="expense_id"
          @conform="refreshPayments"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TableFilters from '@/components/base/TableFilters';
import CategoryForm from './ExpenceCreate';
import { required, email, max } from 'vee-validate/dist/rules';
import pagination from '../../shared/components/pagination';
import { Payment } from '@/models/Payment';
import FileUpload from '@/components/base/FileUpload';
import EditCategoryForm from './ExpenseEdit';
import AddPaymentModel from '../../shared/modals/AddPaymentModel';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { Expenses } from '@/models/Expenses';
import * as moment from 'moment/moment';
import noData from '../../../components/shared/noItem';
extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  data: () => ({
    show: 'false',
    warehouseName: '',
    shopName: '',
    isLoading: false,
    paginationOptions: {},
    isCategoryFormVisible: false,
    payment: [],
    url: 'expense/AddPayment',
    expense_id: null,
    EditScheduleForm: false,
    Expense: new Expenses(),
    pagination1: {
      descending: true,
      page: 1,
      total: 0,
      rowsPerPage: 2,
      sortBy: 'fat',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
      },

      {
        text: 'Shop/Warehouse',
        value: 'shoporwarehouse',
        show: true,
        disabled: false,
      },
      {
        text: 'Expense Category',
        value: 'category.name',
        show: true,
        disabled: false,
      },
      {
        text: 'Note',
        value: 'remark',
        show: true,
        disabled: false,
      },
      {
        text: 'Amount',
        value: 'amount',
        show: true,
        disabled: false,
        align: 'right',
      },
      {
        text: 'Paid Amount',
        value: 'paid_amount',
        show: true,
        disabled: false,
        align: 'right',
      },
      {
        text: 'Due',
        value: 'due',
        show: true,
        disabled: false,
        align: 'right',
      },

      {
        text: 'Expense Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    ProductCategory: [],
    ExpenseForShop: [],
    ExpenseForWarehouse: [],

    filter: {
      name: '',
      search: '',
      status: '',
    },
  }),
  computed: {
    ...mapState(['ShopView']),
    ...mapState(['WarehouseView']),
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    CategoryForm,
    pagination,
    EditCategoryForm,
    FileUpload,
    TableFilters,
    noData,
    AddPaymentModel,
  },

  methods: {
    refreshPayments() {
      this.refreshData();
    },
    warehouseNameFind(item) {
      this.warehouseName = item.warehouse.name;
    },
    shopNameFind(item) {
      this.shopName = item.shop.name;
    },
    ViewCategory(item) {
      this.$router.push(`/masterdata/category/${item.id}`);
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    clearFilter() {
      this.filter = {};
    },
    navigate(item) {},

    OpenModal() {
      this.isCategoryFormVisible = true;
      this.Expense = new Expenses();
    },
    //add payment function
    OpenPayment(data) {
      this.expense_id = data.id;
      this.payment = new Payment();
      this.$refs.PaymentModal.openModal();
    },

    // Expense From Shop
    expenseForShop(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'Shop') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let expenseForShopArray = [value, amount];
      return expenseForShopArray;
    },

    // Expense From Warehouse
    expenseForWarehouse(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'Warehouse') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let expenseForWarehouseArray = [value, amount];
      return expenseForWarehouseArray;
    },

    receiveCategoryData(data) {
      this.ProductCategory = data;
      this.total = this.sumField(this.ProductCategory, 'amount');
      this.ExpenseForShop = this.expenseForShop(
        this.ProductCategory,
        'expense_for',
        'amount',
      );
      this.ExpenseForWarehouse = this.expenseForWarehouse(
        this.ProductCategory,
        'expense_for',
        'amount',
      );
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    AddCategory($event) {
      this.isCategoryFormVisible = false;
    },
    EditModal(data) {
      this.EditScheduleForm = true;

      this.GrtExpenseBySingle(data.id);
    },
    EditCategory($event) {
      this.EditScheduleForm = false;
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += element[filed];
      });
      return value;
    },
    GrtExpenseBySingle(id) {
      this.$store
        .dispatch(`warehouse/GetExpense`, id)
        .then((res) => {
          this.Expense = res.data;
          this.Expense.date = moment(res.data.date).format('YYYY-MM-DD');

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
    getExpenseOrderStatusColor(status) {
      switch (status) {
        case 'Paid':
          return 'green';
          break;
        case 'Not Paid':
          return 'red';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Partially Paid':
          return 'orange';
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.topCard {
  color: white;
}
.min-button::before {
  display: none;
}
.deuamount {
  color: brown;
  font-weight: bold;
}
</style>
